import { getApplicationId, getIsSalesForce } from '@fnol/library/src/lib';
import { translations } from './consts';
import { FirstMessage } from '../components/IntroMesages/FirstMessage';
import { SecondMessage } from '../components/IntroMesages/SecondMessage';
import { ThirdMessage } from '../components/IntroMesages/ThirdMessage';

const introMessagesStepsComposer = () => [
    {
        path: '/stepOne',
        screen: getIsSalesForce(getApplicationId()) ? ThirdMessage : FirstMessage,
        step: 0,
        label: translations.stepLabel.INTRO_START,
    },
    {
        path: '/stepTwo',
        screen: SecondMessage,
        step: 1,
        label: translations.stepLabel.INTRO_DOCUMENTATION,
    },
    {
        path: '/stepThree',
        screen: ThirdMessage,
        step: 2,
        label: translations.stepLabel.INTRO_CONFIRMATION,
    },
];

export default introMessagesStepsComposer;
